import { PROMO_KEY } from 'components/CruiseSearchWidget/constants';
import { Promotion, Selection } from 'components/FiltersProvider/types';
import { CUSTOM_FILTERS_KEY } from 'lib/apiClient';

export function getSelectionUpdatedByPromotion(currentSelection: Selection, promotionData: Promotion): Selection {
	let filtersForFaceting: Selection = { ...currentSelection, [PROMO_KEY]: [], [CUSTOM_FILTERS_KEY]: [] };

	for (const filter in promotionData.criteriaToSearchSelection) {
		if (currentSelection[filter]?.length === 0) {
			filtersForFaceting = { ...filtersForFaceting, [filter]: promotionData.criteriaToSearchSelection[filter] };
		}
	}
	return filtersForFaceting;
}
